export default "__VITE_ASSET__5duf0V$s__"